import React, { useState } from 'react';
import { AccessibleForm, Box, Button, Col, Collapse, NewDateInput, InputMessage, Row, SelectInput, themes, } from '@digitools/honest-react';
import { isAfter, isBefore, parse, isSameDay, format } from 'date-fns';
import styled from 'styled-components';
import { TEALIUM_EVENT } from '../../../../../constants/tealiumConstants';
import useTealium from 'src/hooks/useTealium';
const StyledDiv = styled('div') `
  margin-left: auto; 
  justify-content: right; 
  display: flex;
  @media (max-width: 765px) {
    flex-direction: column;
    margin-left: 0;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
const StyledClearFilterButton = styled(Button) `
  margin-left: auto;
  @media (max-width: 765px) {
    margin-left: 0;
  }
`;
const StyledApplyButton = styled(Button) `
  margin-left: auto;
  @media (max-width: 765px) {
    margin-top: 0.5rem;
    margin-left: 0 !important;
  }
`;
const CorrespondenceFilter = (props) => {
    const [formApi, setFormApi] = useState();
    const { trackEvent } = useTealium();
    if (!props.initialData) {
        return null;
    }
    const validateDateFilter = (values) => {
        if (values.fromDate && !values.throughDate) {
            formApi.setError('throughDate', 'Through date required');
        }
        else if (values.throughDate && !values.fromDate) {
            formApi.setError('fromDate', 'From date required');
        }
        else if (values.fromDate && values.throughDate) {
            const fromDate = parse(values.fromDate, 'P', new Date());
            const throughDate = parse(values.throughDate, 'P', new Date());
            if (isAfter(fromDate, throughDate)) {
                formApi.setError('fromDate', 'From Date must come before Through Date');
            }
        }
    };
    const documentTypes = () => {
        if (!props.initialData) {
            return [];
        }
        else {
            // @ts-ignore
            const types = new Set(props.initialData.map(correspondenceDoc => correspondenceDoc.documentType));
            // convert set to array to use .map()
            return [...types].map(type => {
                return {
                    label: type,
                    value: type,
                };
            });
        }
    };
    const filterCorrespondence = (values) => {
        let filteredData = props.initialData;
        if (values && values.documentType) {
            filteredData = props.initialData.filter((data) => data.documentType === values.documentType);
        }
        if (values && values.fromDate && values.throughDate) {
            const fromDate = parse(values.fromDate, 'MM/dd/yyyy', new Date());
            const throughDate = parse(values.throughDate, 'MM/dd/yyyy', new Date());
            filteredData = props.initialData.filter((data) => {
                const date = data.date ? data.date : data.documentDate;
                const correspondenceDate = parse(format(new Date(date), 'MM/dd/yyyy'), 'MM/dd/yyyy', new Date());
                return (isBefore(fromDate, correspondenceDate) || isSameDay(fromDate, correspondenceDate)) && (isBefore(correspondenceDate, throughDate) || isSameDay(correspondenceDate, throughDate));
            });
        }
        props.setFilteredData(filteredData);
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.SEARCH,
            event_type: TEALIUM_EVENT.EVENT_TYPE.VIEW_STATUS,
            event_name: 'apply',
            event_version: 'correspondence - details'
        });
    };
    const resetFilteredData = () => {
        formApi.reset();
        props.setFilteredData(undefined);
    };
    return (<Box style={{ border: `1px solid ${themes.rebrand.palette.grayLighter}` }}>
      <Collapse title={'Filter'} headerElemType={'h2'} data-testid={'leave-details-filter-correspondence-collapse'} type={'alternate'} theme={themes.rebrand}>
        <AccessibleForm validate={validateDateFilter} onSubmit={filterCorrespondence} getApi={setFormApi}>
          <Row>
            <Col md={6} sm={12}>
              <NewDateInput data-testid={'leave-details-filter-from-date'} field={'fromDate'} ariaLabelText={'From Date'} label={'Document Date - From Date'} theme={themes.rebrand}/>
            </Col>
            <Col md={6} sm={12}>
              <NewDateInput data-testid={'leave-details-filter-through-date'} field={'throughDate'} ariaLabelText={'Through Date'} label={'Document Date - Through Date'} theme={themes.rebrand}/>
            </Col>
          </Row>
          {formApi && formApi.getState().error && (<InputMessage error={true} data-testid={'leave-details-correspondence-filter-error'}>
              {formApi.getState().error}
            </InputMessage>)}
          <Row>
            <Col md={4} sm={12}>
              <SelectInput field={'documentType'} label={'Document Type'} placeholderText={'Document Type...'} options={documentTypes()} data-testid={'leave-details-filter-correspondence-document-type-dropdown'} theme={themes.rebrand} style={{ marginBottom: 0 }}/>
            </Col>
            <Col md={8} sm={12}>
              <StyledDiv>
                <StyledClearFilterButton type={'button'} buttonType={'secondary'} onClick={resetFilteredData} theme={themes.rebrand}>
                  Clear Filter
                </StyledClearFilterButton>
                <StyledApplyButton type={'submit'} buttonType={'primary'} data-testid={'leave-details-correspondence-filter-apply-button'} theme={themes.rebrand}>
                  Apply
                </StyledApplyButton>
              </StyledDiv>
            </Col>
          </Row>
        </AccessibleForm>
      </Collapse>
    </Box>);
};
export default CorrespondenceFilter;
